/**
 * ff-accordion.js
 *
 * Progressive enhancement for the native <details>/<summary> accordions used
 * by ff-proof-section (product disclosures) and ff-faq. The accordion works
 * with zero JavaScript (native browser behavior); this script only adds:
 *   - optional "only one open at a time" behavior per accordion group
 *   - keeping the currently-selected block visibly open in the Theme Editor
 */
(function () {
  'use strict';

  function qsa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function FFAccordionGroup(root) {
    this.root = root;
    this.exclusive = root.dataset.ffAccordionExclusive === 'true';
    this.items = qsa(root, 'details[data-ff-accordion-item]');
    this.onToggle = this.onToggle.bind(this);
    this.items.forEach(
      function (item) {
        item.addEventListener('toggle', this.onToggle);
      }.bind(this)
    );
  }

  FFAccordionGroup.prototype.destroy = function () {
    this.items.forEach(
      function (item) {
        item.removeEventListener('toggle', this.onToggle);
      }.bind(this)
    );
  };

  FFAccordionGroup.prototype.onToggle = function (evt) {
    if (!this.exclusive || !evt.target.open) return;
    this.items.forEach(function (item) {
      if (item !== evt.target) item.open = false;
    });
  };

  function initAll() {
    qsa(document, '[data-ff-accordion-group]').forEach(function (root) {
      if (root.__ffAccordionGroup) return;
      root.__ffAccordionGroup = new FFAccordionGroup(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    qsa(evt.target, '[data-ff-accordion-group]').forEach(function (root) {
      root.__ffAccordionGroup = null;
      root.__ffAccordionGroup = new FFAccordionGroup(root);
    });
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    qsa(evt.target, '[data-ff-accordion-group]').forEach(function (root) {
      if (root.__ffAccordionGroup) {
        root.__ffAccordionGroup.destroy();
        root.__ffAccordionGroup = null;
      }
    });
  });

  // Theme Editor: a selected question must become — and remain — visible
  // (open) until it is deselected, per Shopify's section/block selection
  // guidance. On deselect, it falls back to whatever "open by default" the
  // merchant configured for that block, not necessarily closed.
  document.addEventListener('shopify:block:select', function (evt) {
    var details = evt.target.closest && evt.target.closest('details[data-ff-accordion-item]');
    if (details) details.open = true;
  });

  document.addEventListener('shopify:block:deselect', function (evt) {
    var details = evt.target.closest && evt.target.closest('details[data-ff-accordion-item]');
    if (details) details.open = details.dataset.ffOpenDefault === 'true';
  });
})();
